<div class="wrapper-page">
  <app-my-content></app-my-content>
  <div class="wrapper-my-profile-page">
    <tl-header></tl-header>
    <div class="content-profile-page">
      <div class="wrapper-trending-page">
        <span class="title-trending-page">{{'NEW_TEXT.trending_items' | translate}}</span>
        <span class="subtitle-trending-page">{{'NEW_TEXT.all_trending_items_from_this_company' | translate}}</span>
        <div class="wrapper-trending-content">
          <div class="grid" (scroll)="onScroll($event)">
            <div *ngFor="let item of trendingItems" [routerLink]="[PAGES_AND_PATHS.singleItem.pagePath, item.id]" class="grid__s-6">
              <div class="wrapper-trending-card">
                <div class="header-trending-card">
                  <img class="wrapper-item-img"
                       [src]="item.lyst_item_image_url ? item.lyst_item_image_url : './assets/images/no-image.png'" alt="">
                  <span>{{item.name}}</span>
                </div>
                <div class="content-trending-card">
                  <div class="likes-trending-item" (click)="toggleTrendingItemLike(item)">
                    <div class="btn-trending-like" [ngClass]="{'liked': item.am_i_favorite_this_lyst_item}">
                      <img class="icon-outline" src="../../../assets/icons/outline/icon-heart.svg" alt="">
                      <img class="icon-fill" src="../../../assets/icons/fill/icon-heart.svg" alt="">
                    </div>
                    <span>{{item.favorite_users_count}} {{item.favorite_users_count === 1 ? 'like' : 'likes'}}</span>
                  </div>
                  <div class="wrapper-rating-trending-item">
                    <app-item-rating
                      [averageRating]="item?.average_rating"
                      [reviewsCount]="item?.reviews_count">
                    </app-item-rating>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
